import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import ProfileAvatar from "components/ProfileAvatar/ProfileAvatar";
import ProfileBadges from "components/ProfileBadges/ProfileBadges";
import { Profile } from "types/Profile";
import Icon from "components/Icon/Icon";
import dayjs from "dayjs";
import Status from "common/components/Status/Status";

function SubscriptionItem({ item }: any) {
  const {
    username,
    lastname,
    firstname,
    isCompany,
    companyName,
    isSubscribed,
    subscriptionDate,
    subscriptionEndedDate,
  } = item as Profile;

  const editLink = `/subscriptions/${item.id}`;

  const { t } = useTranslation();

  const isPremium = dayjs(item?.premiumValidUntilDate).isAfter(
    dayjs().startOf("day")
  );

  return (
    <div className="responsive-flex-lg px-4 py-4 mt-2 w-full relative bg-white cursor-pointer rounded-lg border border-slate-150 transition-all">
      <Link to={editLink} className="responsive-flex-lg flex-1">
        <div className="flex relative w-40 h-40 lg:w-16 lg:h-16 xl:w-24 xl:h-24 shrink-0">
          <ProfileAvatar profile={item} />
        </div>
        <div className="flex flex-col flex-1 justify-between lg:pl-4 lg:pr-4">
          <div className="flex h-full gap-3">
            <div className="grid w-full gap-1 pt-3 lg:py-0">
              <div className="grid grid-flow-col items-center ">
                <div className="flex items-center gap-1 mb-1 text-xl">
                  <span className="font-bold text-primary leading-4">
                    {username}
                  </span>
                  {" -  "}
                  <span className="leading-4">{firstname}</span>
                  <span className="leading-4">{lastname}</span>
                </div>
                <div className="flex items-center gap-1 justify-end">
                  <Status status={isPremium ? "premium" : "standard"} small />
                </div>
              </div>

              <div className="grid grid-flow-col items-center ">
                {isCompany && (
                  <div className="flex items-center gap-1 text-sm text-primary">
                    <HiOutlineBuildingOffice2 className="w-4 h-4" />
                    <span className="text-md font-bold">{companyName}</span>
                  </div>
                )}
                <div className="flex flex-row gap-2 items-center justify-end">
                  {isSubscribed ? (
                    <div className="flex items-center gap-1 font-normal leading-[0] text-center text-green-900 bg-green-200 border border-green-400 rounded-md shrink-0 px-2 py-1">
                      <Icon name="Subscription" className="w-5 h-5" />
                      {t("common.subscribedFor", {
                        since: dayjs(subscriptionDate).fromNow(true),
                      })}
                    </div>
                  ) : (
                    <div className="flex items-center gap-1 font-normal leading-[0] text-center text-red-900 bg-red-200 border border-red-400 rounded-md shrink-0 px-2 py-1">
                      <Icon name="Subscription" className="w-5 h-5" />
                      {t("common.unsubscribedSince", {
                        since: dayjs(subscriptionEndedDate).fromNow(true),
                      })}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex flex-row w-full items-center justify-between mt-1 self-end place-self-end justify-self-end">
                <ProfileBadges
                  profile={item}
                  classname="justify-self-end"
                  isSmall
                />
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default SubscriptionItem;
